module.exports = __webpack_public_path__ + "static/media/search.6d4c6526.svg";